module.exports = __webpack_public_path__ + "img/public_6.9a6fb978.jpg";